import React from 'react';
import { Card, Row, Col, Statistic, Progress } from 'antd';
import { CheckCircleOutlined, ExclamationCircleOutlined, InfoCircleOutlined, WarningOutlined } from '@ant-design/icons';

const SystemHealth = ({ data, loading }) => {
  const { SUCCESS = 0, FAILURE = 0, INFO = 0, WARNING = 0, _success_rate = 0 } = data || {};

  return (
    <Card title="" loading={loading}>
      <Row gutter={[16, 16]} align="middle" justify="center">
        <Col span={24} style={{ textAlign: 'center', marginBottom: 24 }}>
          <Progress 
            type="circle" 
            percent={_success_rate} 
            format={(percent) => `${percent}% Success`}
            strokeColor={{
                '0%': '#ff4d4f',
                '100%': '#52c41a',
            }}
          />
        </Col>
        <Col xs={12} sm={6}>
          <Statistic title="Success" value={SUCCESS} prefix={<CheckCircleOutlined style={{color: '#52c41a'}} />} />
        </Col>
        <Col xs={12} sm={6}>
          <Statistic title="Failure" value={FAILURE} prefix={<ExclamationCircleOutlined style={{color: '#ff4d4f'}}/>} />
        </Col>
        <Col xs={12} sm={6}>
          <Statistic title="Info" value={INFO} prefix={<InfoCircleOutlined style={{color: '#1890ff'}}/>} />
        </Col>
        <Col xs={12} sm={6}>
          <Statistic title="Warning" value={WARNING} prefix={<WarningOutlined style={{color: '#faad14'}}/>} />
        </Col>
      </Row>
    </Card>
  );
};

export default SystemHealth;